import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/style/reset.css'
import { initComponents } from './components/index'
const app = createApp(App)
//公共组件初始化
initComponents(app)
app.use(router)
app.mount('#app')
